import request from "root/js/request";

const getAbcTopProductsOzon = async ({
  wb_api_key_ids,
  date_from,
  date_to,
  category_id__in,
  brand_id__in,
  subject_id__in,
  product_id__in,
  barcode__in,
  analyze_by,
  labels,
  xyz_labels,
  reverse,
  ...rest
}) => {
  const response = await request({
    url: "/ozon_analytics/abc_analysis/top_products/",
    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      category_id__in,
      brand_id__in,
      subject_id__in,
      product_id__in,
      barcode__in,
      analyze_by,
      labels,
      xyz_labels,
      reverse,
      ...rest,
    },
  });
  return response.data;
};

export { getAbcTopProductsOzon };
